import React, {Component} from 'react';
import {Bar} from 'react-chartjs-2';

const SIMPLE_COLOR = [ 129,205,234]
const COMPLEX_COLOR = [ 255, 131, 77]

class MyBar extends Component {

    calculateBarColors(groups, selectedValue){

        let gradient = (fromColor, toColor, ratio) => fromColor.map((color, index) => {
            return Math.round(fromColor[index] * (1-ratio) + toColor[index] * ratio);
        });

        return groups.map((group, index) => {
            if(group.min <= selectedValue && group.max + 0.001 >= selectedValue){
                return "#2e3131"
            }
            return  `rgb(${gradient(SIMPLE_COLOR, COMPLEX_COLOR, index / groups.length).join(",")})`
        });
    }

    render() {
        let artifactCount = this.props.data.length;
        let min = Math.min.apply(null, this.props.data.map(item => item.value));
        let max = Math.max.apply(null, this.props.data.map(item => item.value));

        let nRanges = 20;
        let range = (max - min) / nRanges;

        let groups = []
        for(let i = 0; i < nRanges ; i++ ){
            let currentMin = min + (i) * range;
            let currentMax = min + (i + 1) * range;

            let count = this.props.data.filter( item => item.value >= currentMin && item.value < currentMax + 0.001).length ;
            groups.push({
                min : currentMin, 
                max : currentMax,
                count : count,
                label : `${ Math.round(currentMin)} - ${Math.round(currentMax)}`
            })
        }

        let graphData = {
            labels : groups.map(group => group.label),
            datasets : [
                {
                    borderWidth: 1,
                    data :  groups.map(group => group.count),
                    backgroundColor : this.calculateBarColors(groups, this.props.selectedValue)
                }
            ]
        }

        return (
            <div className='complexity-chart-container'>
                <Bar
                    data={graphData}
                    options={{
                        legend: { display: false },
                        scales: {
                            yAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: '# Assets'
                                }
                            }],
                            xAxes: [{
                                scaleLabel: {
                                    display: true,
                                    labelString: 'Complexity'
                                }
                            }],
                        },
                        tooltips: {
                            mode: 'label',
                            callbacks: {
                                title: function(tooltipItem, data) { return null; },
                                beforeLabel: function(tooltipItem, data) { return null; },
                                label: function(tooltipItem, data) {
                                    const count = tooltipItem.yLabel;
                                    const complexity = tooltipItem.xLabel;
                                    const percentage = Math.round((tooltipItem.yLabel / artifactCount) * 100);
                                    return ` ${percentage}% (${count} of ${artifactCount}) of your upload's artifacts have a complexity rating of ${complexity}`;
                                },
                            }
                        }
                    }}
                />
            </div>
        );
    }
};

export default MyBar;
